import { Component, OnDestroy, OnInit } from '@angular/core';
import { IAddress } from '@shared-models/address.model';
import { ICalendarAddressFilter, IFormGroup } from '@shared-libs/interfaces';
import { CalendarAddressFilterFormFactory } from '@internal-factories/forms/calendar-address-filter-form.factory';
import { Output, EventEmitter } from '@angular/core';
import { StateManager } from '@shared-managers/state.manager';
import { cloneDeep } from 'lodash';

const FILTER_STATE_KEY = 'calendar-address-filter';

@Component({
	selector: 'calendar-address-filter',
	templateUrl: './calendar-address-filter.component.html',
	styleUrls: ['./calendar-address-filter.component.scss'],
})
export class CalendarAddressFilterComponent implements OnInit, OnDestroy {
	public calendarAddressFilterForm: IFormGroup<ICalendarAddressFilter>;
	public currentAddress: IAddress;
	private range: number;
	@Output() filter = new EventEmitter<ICalendarAddressFilter>();

	constructor(private readonly stateManager: StateManager) {}

	public ngOnInit(): void {
		const state = this.stateManager.getState<IFormGroup<ICalendarAddressFilter>>(FILTER_STATE_KEY) ?? null;
		if (state) {
			this.calendarAddressFilterForm = state;
			this.currentAddress = this.calendarAddressFilterForm.get('address').value;
		} else {
			this.calendarAddressFilterForm = CalendarAddressFilterFormFactory.create();
		}

		this.calendarAddressFilterForm.get('range').valueChanges.subscribe((range: number) => {
			this.range = range;
		});
	}

	public ngOnDestroy(): void {
		this.stateManager.setState(FILTER_STATE_KEY, cloneDeep(this.calendarAddressFilterForm));
		this.calendarAddressFilterForm.reset();
	}

	public onAddressSelected(address: IAddress): void {
		this.currentAddress = address;
		this.calendarAddressFilterForm.patchValue({
			address,
			coordinates: {
				lat: address.lat,
				long: address.long,
			},
			zipcode: address.zipcode,
		});
		this.emitValues();
	}

	public onAddressRangeChanged() {
		if (this.calendarAddressFilterForm.value.coordinates) {
			this.emitValues(this.range);
		}
	}

	public emitValues(range?: number) {
		const values = this.calendarAddressFilterForm.value;
		this.filter.emit({ ...values, range: range ?? values.range });
	}

	public clearAddress() {
		this.currentAddress = null;
		this.calendarAddressFilterForm.patchValue({
			coordinates: null,
			zipcode: null,
			address: null,
		});
		this.stateManager.removeState(FILTER_STATE_KEY);
		this.emitValues();
	}

	public adjustRangeColor(value: number): string {
		if (value <= 5) {
			return '#78BC61';
		}
		if (value <= 15) {
			return '#edb142';
		}
		return '#EB4B24';
	}
}
